import { topics } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门话题标签
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            全网吃瓜群众正在热议的话题关键词，点击探索更多相关内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className="flex items-center gap-3 px-4 py-3 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-200 cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                #{topic.name}
              </span>
              <div className="flex items-center gap-2">
                <span className="text-xs text-foreground-400 whitespace-nowrap">
                  热度 {topic.heat}
                </span>
                <span className="text-[10px] text-foreground-300 whitespace-nowrap">
                  {topic.posts}帖
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}